import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const EventRow = ({ event, index }) => (
  <Reveal delay={index * 0.08}>
    <article
      data-testid={`event-row-${index}`}
      className="group grid grid-cols-[auto_1fr] items-center gap-6 border-b border-ink py-8 transition-colors duration-300 hover:bg-navy/5 md:grid-cols-[auto_1fr_auto] md:gap-12 md:py-10"
    >
      <div className="font-oswald leading-none">
        <span className="block text-5xl font-semibold md:text-7xl">{event.day}</span>
        <span className="mt-2 block text-sm uppercase tracking-[0.2em] text-orange">{event.month}</span>
      </div>
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        {event.image && (
          <img
            src={event.image}
            alt={event.title}
            loading="lazy"
            className="h-40 w-full flex-shrink-0 border border-ink object-cover sm:h-24 sm:w-32"
          />
        )}
        <div>
          <h3 className="font-oswald text-xl font-semibold uppercase tracking-tight md:text-3xl">{event.title}</h3>
          <p className="mt-2 max-w-xl text-sm leading-relaxed opacity-80">{event.description}</p>
        </div>
      </div>
      <div className="col-span-2 md:col-span-1 md:text-right">
        <p className="text-xs uppercase tracking-[0.2em] opacity-60">{event.place}</p>
        <ArrowUpRight className="mt-3 h-6 w-6 text-orange transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 md:ml-auto" />
      </div>
    </article>
  </Reveal>
);
